export const NotificationIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.74902 1.375C8.74902 0.960786 8.41324 0.625 7.99902 0.625C7.58481 0.625 7.24902 0.960786 7.24902 1.375V2.43088C4.84339 2.79274 2.99902 4.86848 2.99902 7.375V11.875V11.8824H2.74902C2.33481 11.8824 1.99902 12.2182 1.99902 12.6324C1.99902 13.0466 2.33481 13.3824 2.74902 13.3824H5.99904C6.00303 14.4836 6.89693 15.375 7.99902 15.375C9.10112 15.375 9.99501 14.4836 9.99901 13.3824H13.249C13.6632 13.3824 13.999 13.0466 13.999 12.6324C13.999 12.2182 13.6632 11.8824 13.249 11.8824H12.999V11.875V7.375C12.999 4.86848 11.1547 2.79274 8.74902 2.43088V1.375ZM8.49902 11.875H8.83902H9.99902H10.339H11.499V7.375C11.499 5.442 9.93202 3.875 7.99902 3.875C6.06603 3.875 4.49902 5.442 4.49902 7.375V11.875H5.65902H5.99902H7.15902H7.49902H8.49902ZM7.99902 14.215C8.46047 14.215 8.83501 13.8429 8.83899 13.3824H7.15906C7.16304 13.8429 7.53758 14.215 7.99902 14.215Z"
        fill="#3E3E3E"
      />
    </svg>
  )
}
